let fetch;

if (process.env.SERVER) {
  fetch = require('make-fetch-happen').defaults({
    cache: 'no-store',
    cachePath: process.env.SSR_REQUEST_CACHE === 'true' ? './.request-cache' : null
  });
} else {
  fetch = require('whatwg-fetch').fetch;
}

export default fetch;



// WEBPACK FOOTER //
// ./utils/fetch.js